var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterConces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1_1_",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core_1_",
    transform: "translate(-465 -216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter_1_",
    transform: "translate(465 216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "cls-1",
    d: "M7,12h4V10H7v2ZM0,0V2H18V0ZM3,7H15V5H3V7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterConces);
export default __webpack_public_path__ + "static/media/filter_conces.163a22bb11fb4c3f4d59611796f83e0b.svg";
export { ForwardRef as ReactComponent };